module.exports = __webpack_public_path__ + "img/binary_to.5ea6e3f2.png";